module.exports = __webpack_public_path__ + "img/instagram.211c43c.svg";